import classNames from "classnames";
import React, { ReactNode, useRef } from "react";
import useHasScrollbar from "../../hooks/useHasScrollbar";

export type Props = {
  secondary?: ReactNode;
  toolbar?: ReactNode;
};

const TwoColumnLayout: React.FC<Props> = ({ children, toolbar, secondary }) => {
  const mainEl = useRef(null);
  const [hasScrollGutter] = useHasScrollbar(mainEl);

  return (
    <div className="cw-flex cw-h-screen cw-overflow-hidden cw-relative">
      {secondary && secondary}
      <div className="cw-flex cw-flex-col cw-grow">
        <main
          ref={mainEl}
          className={classNames("cw-grow cw-overflow-auto cw-h-full cw-bg-default")}
        >
          <div className="cw-w-full cw-h-full cw-flex cw-justify-center">{children}</div>
        </main>
      </div>
      {toolbar && (
        <div className="cw-absolute cw-top-0 cw-right-0">
          <div
            className={classNames("cw-absolute cw-top-2 cw-right-2", {
              "cw-right-5": hasScrollGutter,
            })}
          >
            {toolbar}
          </div>
        </div>
      )}
    </div>
  );
};

export default TwoColumnLayout;
